function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M47.9518 64.0867L30.9775 12.1402L36.2932 10.4688L52.9995 61.6235L52.4411 62.6571L47.9518 64.0867Z",
  fill: "#EA5554"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.1233 72.0264L3.41699 20.8716L8.73263 19.2002L25.6846 71.1467L21.173 72.5542L20.1233 72.0264Z",
  fill: "#EA5554"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.41292 20.879L5.12207 26.1133L37.994 15.7057L36.2848 10.4715L3.41292 20.879Z",
  fill: "#EA5554"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-0.00798366 10.4181L1.70117 15.6523L34.5731 5.24478L32.8639 0.0105458L-0.00798366 10.4181Z",
  fill: "#EA5554"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.8035 64.9689L19.5127 70.2031L52.3846 59.7956L50.6754 54.5613L17.8035 64.9689Z",
  fill: "#EA5554"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.9922 74.4893L50.4983 66.418L46.9024 73.3236L32.0052 78.0301L24.9922 74.4893Z",
  fill: "#EA5554"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.874 80.493L39.4202 75.6106L42.7257 69.2548L48.0413 59.1162L52.9996 61.6234L52.4412 62.657L50.4981 66.4178L46.9023 73.3234L46.5226 74.0272L44.5125 77.8759L44.4008 78.1178L41.8323 83.0002L36.874 80.493Z",
  fill: "#EA5554"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.123 72.0264L22.6692 67.1221L32.4964 72.1144L39.4201 75.6112L39.5318 75.6552L44.4008 78.1184L41.8323 83.0007L20.123 72.0264Z",
  fill: "#EA5554"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 53,
  height: 83,
  fill: "white"
})));

var SvgCreateCampaignIcon = function SvgCreateCampaignIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 83,
    viewBox: "0 0 53 83",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreateCampaignIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/create-campaign-icon.a0908c3a.svg";
export { ForwardRef as ReactComponent };